export const MAP_STATUS_ICON = {
  FAILED: {
    color: '#E5202E',
    description: 'Orchestration failed',
    name: 'wk-icon-close-circle',
    size: 20,
  },
  FINISHED: {
    color: '#85BC20',
    description: 'Orchestration finished',
    name: 'wk-icon-check-circle',
    size: 20,
  },
  FINISHED_ERROR: {
    color: '#85BC20',
    description: 'Orchestration finished with errors',
    name: 'wk-icon-check-circle',
    size: 20,
  },
  IN_PROGRESS: {
    color: '#EA8F00',
    description: 'Orchestration in progress',
    name: 'wk-icon-clock',
    size: 20,
  },
  PENDING: {
    color: 'black',
    description: 'Orchestration pending',
    name: 'wk-icon-infinity',
    size: 20,
  },
  STOPPED: {
    color: '#721017',
    description: 'Orchestration stopped',
    name: 'wk-icon-close-circle',
    size: 20,
  },
  STOPPING: {
    color: '#721017',
    description: 'Orchestration stopping',
    name: 'wk-icon-stop-sign',
    size: 20,
  },
};
